import { useParams } from 'react-router-dom';
import { FORMATION_KINDS, formationKindType } from '../../types';
import { FormationContinueEntryForm } from './FormationContinueEntryForm';
import { FormationInitialeEntryForm } from './FormationInitialeEntryForm';

function FormationEntry() {
    const params = useParams();
    if (!params.id || !params.kind) {
        return <div>Missing parameters in URL</div>;
    }

    const id = params.id;
    const kind = params.kind as formationKindType;

    if (FORMATION_KINDS.includes(kind) === false) {
        return <div>Invalid formation kind: {params.kind}</div>;
    }

    return renderForm(kind, id);

    function renderForm(kind: formationKindType, id: string) {
        switch (kind) {
            case 'formation-initiale':
                return <FormationInitialeEntryForm id={id} />;
            case 'formation-continue':
                return <FormationContinueEntryForm id={id} />;
        }
    }
}

export { FormationEntry };
